import { cn } from '@/lib/utils';

interface TenantBadgeProps {
  tenantName: string;
  brandColor?: string | null;
  className?: string;
  textClassName?: string;
  density?: 'default' | 'compact';
}

export function TenantBadge({
  tenantName,
  brandColor,
  className,
  textClassName,
  density = 'default',
}: TenantBadgeProps) {
  const isCompact = density === 'compact';

  return (
    <span
      className={cn(
        'inline-flex max-w-[13rem] items-start font-medium text-foreground/90 text-left',
        isCompact ? 'gap-1.5 text-xs' : 'gap-2 text-xs',
        className
      )}
      title={tenantName}
      aria-label={`Tenant: ${tenantName}`}
    >
      <span
        className={cn(
          'shrink-0 rounded-sm bg-muted-foreground/40',
          isCompact ? 'h-3 w-[3px] mt-[1px]' : 'h-3.5 w-1.5 mt-0.5'
        )}
        style={brandColor ? { backgroundColor: brandColor } : undefined}
        aria-hidden="true"
      />
      <span className={cn('min-w-0 whitespace-normal break-words leading-snug', textClassName)}>
        {tenantName}
      </span>
    </span>
  );
}
